import React, { useContext, useEffect, useRef, useState } from 'react'
import NewsFilters from './NewsFilters'
import queryString from 'query-string'

const News = () => {
  const [newsStarter, setNewsStarter] = useState([])
  const [newsTopStory, setNewsTopStory] = useState([])
  const [newsCount, setNewsCount] = useState([])
  const [newsLoaded, setNewsLoaded] = useState(false)

  const [filters, setFilters] = useState({
    query: '',
  })

  useEffect(() => {
    const query = queryString.stringify(filters, {
      arrayFormat: 'bracket',
    })

    fetch(`/news_posts.json?${query}`)
      .then((response) => response.json())
      .then((data) => {
        setNewsStarter(data.newsStarter)
        setNewsTopStory(data.newsTopStory)
        setNewsCount(data.newsPostCount)
        setNewsLoaded(true)
      })
  }, [filters])

  return (
    <div>
      <section className='news'>
        <section className='news__hero'>
          {newsTopStory.length > 0 ? (
            <div className='news__top-story-cards'>
              {newsTopStory.map((post, index) => (
                <div
                  key={index}
                  className='news__top-story-cards__card top-story-card'
                >
                  {post.featured ? (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='top-story-card__image-container-link-wrapper'
                    >
                      <div className='top-story-card__image-container'>
                        <img
                          src={post.imgUrl}
                          alt={post.imgAlt}
                          className='top-story-card__image-container__image'
                        />
                        <div className='top-story-card__image-container__featured'>
                          <p>Featured Asset</p>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='top-story-card__image-container-link-wrapper'
                    >
                      <div className='top-story-card__image-container'>
                        <img
                          src={post.imgUrl}
                          alt={post.imgAlt}
                          className='top-story-card__image-container__image'
                        />
                      </div>
                    </a>
                  )}

                  <div className='top-story-card__content'>
                    {post.featuredNewsType ? (
                      <p className='top-story-card__content__date'>
                        {post.publishedAt}{' '}
                        <span className='top-story-card__content__date__divider'>
                          |
                        </span>{' '}
                        {post.featuredNewsType}
                      </p>
                    ) : (
                      <p className='top-story-card__content__date'>
                        {post.publishedAt}
                      </p>
                    )}

                    <h3 className='top-story-card__content__heading'>
                      <a
                        href={post.slug}
                        className='top-story-card__content__heading__link'
                      >
                        {post.title}
                      </a>
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          ) : null}

          {newsStarter.length > 0 ? (
            <div className='news__cards'>
              {newsStarter.map((post, index) => (
                <div
                  key={index}
                  className={
                    post.featured
                      ? 'news__cards__card featured-card'
                      : 'news__cards__card news-card'
                  }
                >
                  {post.featured ? (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='featured-card__image-container-link-wrapper'
                    >
                      <div className='featured-card__image-container'>
                        {post.imgUrl ? (
                          <img
                            src={post.imgUrl}
                            alt={post.imgAlt}
                            className='featured-card__image-container__image'
                          />
                        ) : (
                          <img
                            src='/assets/news-placeholder-image1.png'
                            alt='RADical ImPAct Placeholder Image'
                            className='featured-card__image-container__image'
                          />
                        )}
                        <div className='featured-card__image-container__featured'>
                          <p>Featured Asset</p>
                        </div>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={post.link ? post.link : post.slug}
                      className='news-card__image-container-link-wrapper'
                    >
                      <div className='news-card__image-container'>
                        {post.imgUrl ? (
                          <img
                            src={post.imgUrl}
                            alt={post.imgAlt}
                            className='news-card__image-container__image'
                          />
                        ) : (
                          <img
                            src='/assets/news-placeholder-image1.png'
                            alt='RADical ImPAct Placeholder Image'
                            className='news-card__image-container__image'
                          />
                        )}
                      </div>
                    </a>
                  )}

                  <div className='news-card__content'>
                    {post.newsType ? (
                      <p className='news-card__content__date'>
                        {post.publishedAt}{' '}
                        <span className='news-card__content__date__divider'>
                          |
                        </span>{' '}
                        {post.newsType}
                      </p>
                    ) : (
                      <p className='news-card__content__date'>
                        {post.publishedAt}
                      </p>
                    )}

                    <h3 className='news-card__content__heading'>
                      {post.link ? (
                        <a
                          href={post.link}
                          className='news-card__content__heading__link news-card__content__heading__link--external'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {post.customText}
                        </a>
                      ) : (
                        <a
                          href={post.slug}
                          className='news-card__content__heading__link'
                        >
                          {post.title}
                        </a>
                      )}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          ) : newsLoaded ? (
            <p>There are no posts.</p>
          ) : null}
        </section>

        {newsCount > 8 ? (
          <div className='news__cards__all-posts'>
            <a
              href='/news_posts/all'
              className='news__cards__all-posts__button button'
            >
              See All Stories
            </a>
          </div>
        ) : (
          <div></div>
        )}
      </section>
    </div>
  )
}

export default News
